"use client";

import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

/**
 * Passwortfeld mit Klartext-Anzeigen-Toggle (Feedback-Runde 10 Punkt 2, 2026-07-22:
 * "Augen-Symbol an beiden Feldern, mit dem man sich das eingegebene Passwort im
 * Klartext anzeigen lassen kann"). Geteilt zwischen AuthModal (Login/Registrierung)
 * und der Reset-Password-Seite statt dreifach dupliziert.
 */
export function PasswordInput({
  value,
  onChange,
  placeholder,
  ariaLabel,
  autoComplete,
  className,
}: {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  ariaLabel: string;
  autoComplete?: string;
  className?: string;
}) {
  const [visible, setVisible] = useState(false);

  return (
    <div className="relative">
      <Input
        type={visible ? "text" : "password"}
        required
        minLength={6}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        aria-label={ariaLabel}
        autoComplete={autoComplete}
        className={cn("bg-card pr-9", className)}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? "Passwort verbergen" : "Passwort anzeigen"}
        className="absolute top-1/2 right-2.5 -translate-y-1/2 text-muted-foreground hover:text-ink"
      >
        {visible ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
}
